import { fromJS } from 'immutable';
import { partnerPortionPaymentTypeNamesMap } from '../../enums/paymentTypes';

export default fromJS({
    paymentTypes: [...Object.entries(partnerPortionPaymentTypeNamesMap)].map(([id, name]) => ({ id: Number(id), name }))
});
